import { accessibilitySelectors, useSelector } from 'src/store';

import { useFontStyles } from './fonts';
import { useTheme } from './theme';
export const GlobalStyle = () => {
  // TOOLS
  const fontStyles = useFontStyles();
  const theme = useTheme();
  // SELECTORS

  //**Dark Mode */
  const selectIsDarkMode = useSelector(accessibilitySelectors.selectIsDarkMode);

  // eslint-disable-next-line react/react-in-jsx-scope
  return (
    <style>{`
		:root {
			--color-mode:${selectIsDarkMode ? theme.colors.white1 : theme.colors.dark};
			--color-mode-reverse:${
        selectIsDarkMode ? theme.colors.dark : theme.colors.white2
      };
	  --color-new-blue:${
      selectIsDarkMode ? theme.colors.newBlue : theme.colors.white2
    };

			--spacing-tiny: ${theme.spacing.tiny}px;
			--spacing-small: ${theme.spacing.small}px;
			--spacing-medium: ${theme.spacing.medium}px;
			--spacing-large: ${theme.spacing.large}px;
			--spacing-xLarge: ${theme.spacing.xLarge}px;
			--spacing-xxLarge: ${theme.spacing.xxLarge}px;
			--spacing-xxxLarge: ${theme.spacing.xxxLarge}px;
			--spacing-xxxLarge200: ${theme.spacing.xxxLarge200}px;;
			
		}

		${fontStyles}
		
		html, body, div, span, applet, object, iframe,
		h1, h2, h3, h4, h5, h6, p, blockquote, pre,
		a, abbr, acronym, address, big, cite, code,
		del, dfn, em, img, ins, kbd, q, s, samp,
		small, strike, strong, sub, sup, tt, var,
		b, u, i, center,
		dl, dt, dd, ol, ul, li,
		fieldset, form, label, legend,
		table, caption, tbody, tfoot, thead, tr, th, td,
		article, aside, canvas, details, embed,
		figure, figcaption, footer, header, hgroup,
		menu, nav, output, ruby, section, summary,
		time, mark, audio, video {
			margin: 0;
			padding: 0;
			border: 0;
			font-size: 100%;
			font: inherit;
			vertical-align: baseline;
		}
		body, body .ant-layout {
			background-color:var(--color-mode);
			height:100%;
			// min-height: 700px;
		}
		body, #root{
			height:100%;
		}
	}
	`}</style>
  );
};
